import React, {ChangeEvent, Dispatch, useState} from 'react';
import {CATEGORIES, CategoryData} from "../../enums/categories";
import './register-form.scss'
import {setError} from "../errors";
import {getVotesCategoryStore} from "../../actions/vote-store";
import Privacy from "../terms/privacy";
import Gdpr from "../terms/gdpr";
import { validateEmail, validatePhone } from "../../helpers/utils";

export interface User {
	Firstname: string,
	Lastname: string,
	City: string,
	Phone: string,
	Email: string,
	AgreeGDPR: string,
	AgreeGeneralTerms: string
}

const emptyUser: User = {
	Firstname: '',
	Lastname: '',
	City: '',
	Phone: '',
	Email: '',
	AgreeGDPR: '',
	AgreeGeneralTerms: ''
}

interface Props {
	currentCategory: number;
	onSubmit: (user: User) => void
	setShow: Dispatch<boolean>
	setCategory: Dispatch<number>
	setAlertServiceValues: Dispatch<{ type: string, message: string }>
	submitDisabled: boolean
}

const RegisterForm = ({currentCategory, onSubmit, setShow, setAlertServiceValues, setCategory, submitDisabled}: Props) => {
	
	const [user, setUser] = useState(emptyUser);
	const [showTerms, setShowTerms] = useState(false);
	const [showShowGDPR, setShowGDPR] = useState(false);
	const setUserForm = (e: ChangeEvent<HTMLInputElement>) => {
		// @ts-ignore
		user[e.target.name] = e.target.value
		setUser(user)
	};
	
	const submit = (event: any) => {
		event.preventDefault();
		for (let category = CATEGORIES.BG_PESEN; category <= CATEGORIES.BG_VIDEOKLIP; category++) {
			const categoryVotes = getVotesCategoryStore(category)
			if(typeof categoryVotes === "undefined" || categoryVotes.length < 5) {
				if((categoryVotes.length > 5)) {
					const numberToVote =(5 - categoryVotes.length) * -1
					setError(`Избрали сте ${numberToVote} от възможни 5 от категория ${CategoryData[category].title}`, setShow, setAlertServiceValues)
					setCategory(category);
					return;
				}
				const numberToVote =typeof categoryVotes === "undefined" ? 5 : (5 - categoryVotes.length)
				setError(`Трябва да изберете още ${numberToVote} от категория ${CategoryData[category].title}`, setShow, setAlertServiceValues)
				setCategory(category);
				return;
			}
		}
		// @ts-ignore
		if (!document.getElementById('general-terms').checked) {
			setError(`Трябва да се съгласите с общите условията`, setShow, setAlertServiceValues)
			return;
		}
		// @ts-ignore
		else if (!document.getElementById('gdpr').checked) {
			setError(`Трябва да се съгласите с условията за обработка на лични данни`, setShow, setAlertServiceValues)
			return;
		} else if (!user.Firstname) {
			setError(`"Име" е задължително поле`, setShow, setAlertServiceValues)
			return;
		} else if (!user.Lastname) {
			setError(`"Фамилията" е задължително поле`, setShow, setAlertServiceValues)
			return;
		} else if (!user.Phone) {
			setError(`"Телефон" е задължително поле`, setShow, setAlertServiceValues)
			return;
		} else if (!user.Email) {
			setError(`"Email" е задължително поле`, setShow, setAlertServiceValues)
			return;
		} else if (!user.City) {
			setError(`"Град" е задължително поле`, setShow, setAlertServiceValues)
			return;
		}

		if (!validateEmail(user.Email)) {
			setError(`Полето "Email" е невалидно`, setShow, setAlertServiceValues)
			return;
		}

		if (!validatePhone(user.Phone)) {
			setError(`Полето "Телефон" е невалидно`, setShow, setAlertServiceValues)
			return;
		}

		onSubmit(user);
	}

	const renderRegisterForm = React.useMemo(() => {
		return <div className="category-list-inner-wrap npb">
			<h5 className="card-title category-name">
				{Object.values(CategoryData)[currentCategory].title}
			</h5>
			<div className="form-group">
				<label>Име <span className="required">*</span></label>
				<input type="text" className="form-control" onChange={setUserForm} name="Firstname"
					placeholder="Въведете Име"/>
			</div>
			
			<div className="form-group">
				<label>Фамилия <span className="required">*</span></label>
				<input type="text" className="form-control" onChange={setUserForm} name="Lastname"
					placeholder="Въведете Фамилия"/>
			</div>
			
			<div className="form-group">
				<label>Град <span className="required">*</span></label>
				<input type="text" className="form-control" onChange={setUserForm} name="City" placeholder="Въведете Град"/>
			</div>
			
			<div className="form-group">
				<label>Телефон <span className="required">*</span></label>
				<input type="text" className="form-control" onChange={setUserForm} name="Phone"
					placeholder="Въведете Телефон"/>
			</div>
			
			<div className="form-group">
				<label>Email <span className="required">*</span></label>
				<input type="email" className="form-control" onChange={setUserForm} name="Email"
					placeholder="Въведете Email"/>
			</div>
		</div>
	}, []);

	const renderAgreements = React.useMemo(() => {
		return <div className='form-group form-agreements'>
			<div className="form-check">
				<input type="checkbox" className="form-check-input" onChange={setUserForm} name="AgreeGDPR" id="gdpr"
					value={"agree"}/>
				<label className="form-check-label" htmlFor="gdpr">
					Предоставям доброволно данните си <span className="required">*</span>
					{/** <a href='#gdpr' className={'information'} data-toggle="modal" data-target="#gdpr" onClick={() => setShowGDPR(true)}>Информация</a> */}
					<a href='https://www.bgradio.bg/page/nppd' className={'information'} target="_blank">Информация</a>
				</label>
			</div>
			<div className="form-check">
				<input type="checkbox" className="form-check-input" onChange={setUserForm} name="AgreeGeneralTerms"
					id="general-terms" value={"agree"}/>
				<label className="form-check-label" htmlFor="general-terms">
					Съгласен съм с общите условия <span className="required">*</span><a href='#terms' className={'information'} data-toggle="modal" data-target="#terms" onClick={() => setShowTerms(true)}>Информация</a>
				</label>
			</div>
			<Privacy show={showTerms} hide={(e: any) => setShowTerms(e)} />
			<Gdpr show={showShowGDPR} hide={(e: any) => setShowGDPR(e)} />
		</div>
	}, [showTerms, showShowGDPR]);

	const renderSubmitBtn = React.useMemo(() => {
		return <div className="register-button-wrap">
			<div className="input-field col s12">
				<button onClick={submit} disabled={submitDisabled} className="btn waves-effect waves-light col-sm-12">Гласувай</button>
			</div>
		</div>
	}, [submitDisabled]);
	
	return (
		<div className="nominations container">
			<div className="row category-list" id={'register-page'}>
				{renderRegisterForm}
				{renderAgreements}
				{renderSubmitBtn}
			</div>
		</div>
	);
}

export default RegisterForm;